<template>
  <div>
    <!-- 乘車注意事項彈窗 -->
    <div class="overlay" :class="{ active: showNoticeModal }">
      <div class="dialog dialog--notice">
        <div class="dialog-header">
          <span class="dialog-title">Boarding Notice</span>
          <!-- 點叉叉關閉彈窗 -->
          <button class="dialog-close" @click="closeNoticeModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="dialog-body">
          <ul class="notice-modal-list">
            <li v-for="(note, idx) in busNoticeData" :key="idx">{{ note }}</li>
          </ul>
        </div>
        <div class="dialog-footer">
          <!-- 點 I understand 效果同叉叉 -->
          <button class="btn-notice-confirm" @click="closeNoticeModal">I understand</button>
        </div>
      </div>
    </div>

    <form class="tran-select-area" @submit.prevent="handleSubmit">
      <!-- 出發站下拉選單 -->
      <div class="tran-input-group">
        <label>Departure</label>
        <select v-model="form.stationStart" class="form-control">
          <option value="">All</option>
          <option
            v-for="(station, idx) in busStationData"
            :key="idx"
            :value="station.code"
          >
            {{ station.code }}
          </option>
        </select>
      </div>
      <!-- 抵達站下拉選單 -->
      <div class="tran-input-group">
        <label>Arrival</label>
        <select v-model="form.stationEnd" class="form-control">
          <option value="">All</option>
          <option
            v-for="(station, idx) in busStationData"
            :key="idx"
            :value="station.code"
          >
            {{ station.code }}
          </option>
        </select>
      </div>
      <!-- 出發日期 & 時間，預設為今天現在時刻 -->
      <div class="tran-input-group">
        <label>Depart at (GMT+8)</label>
        <div class="form-control date-input d-flex justify-content-between">
          <input v-model="form.expectDepartureDate" type="date" />
          <input v-model="form.expectDepartureTime" type="time" />
        </div>
      </div>
      <!-- 車型下拉選單 -->
      <div class="tran-input-group">
        <label>Bus Type</label>
        <select v-model="form.busType" class="form-control">
          <option value="" selected>All</option>
          <option
            v-for="(type, idx) in busTypeList"
            :key="idx"
            :value="type.code"
          >
            {{ type.name }}
          </option>
        </select>
      </div>
      <button type="submit" class="tran-table-btn btn btn-block btn-primary" :disabled="isLoading">Search</button>
    </form>
    <div class="tran-table-outlay table-responsive px-2">
      <template v-if="!resultData.length">
        <div class="empty-outlay">
          <!-- 載入中：顯示旋轉 icon -->
          <div v-if="isLoading" class="loading active">
            <div class="icon"><i class="fa fa-circle-o-notch fa-spin"></i></div>
          </div>
          <!-- 無資料：顯示空狀態圖片 -->
          <div v-else class="empty-status">
            <img src="/img/bus_no_result.svg" alt />
            <div class="title">No Result</div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- 手機/平板版：卡片列表 (完整顯示 6 站時間 + 車型 + 航班) -->
        <div class="bus-card-list d-lg-none">
          <div
            v-for="(bus, busIdx) in resultData"
            :key="busIdx"
            class="bus-card"
          >
            <div class="bus-card-stations">
              <div
                v-for="(time, timeIdx) in formatBusTime(bus.stationList)"
                :key="timeIdx"
                class="bus-card-station"
              >
                <div class="bus-card-station-code">{{ fields[timeIdx] }}</div>
                <div class="bus-card-station-time">{{ time }}</div>
              </div>
            </div>
            <div class="bus-card-meta">
              <span class="bus-card-type">
                {{ bus.busType }}
                <span v-if="bus.vehicleType">({{ bus.vehicleType }})</span>
              </span>
                <span v-if="bus.flightList" class="bus-card-flight">
                {{ Array.isArray(bus.flightList) ? bus.flightList.join(', ') : bus.flightList }}
              </span>
            </div>
          </div>
        </div>
        <!-- 桌面版：原本 table -->
        <table class="table table-hover d-none d-lg-table">
          <thead>
            <tr class="head-fixed">
              <th v-for="(field, idx) in fields" :key="idx">{{ field }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(bus, busIdx) in resultData" :key="busIdx">
              <!-- 各站時間 -->
              <td v-for="(time, timeIdx) in formatBusTime(bus.stationList)" :key="timeIdx">
                {{ time }}
              </td>
              <td>
                {{ bus.busType }}
                <br />
                <span v-if="bus.vehicleType">({{ bus.vehicleType }})</span>
              </td>
              <td>{{ Array.isArray(bus.flightList) ? (bus.flightList).join(', ') : bus.flightList }}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>
    <!-- 底部注意事項 -->
    <ul class="card-footer pl-4 pt-3">
      <li v-for="(note, idx) in busNoticeData" :key="idx" class="notice-text">{{ note }}</li>
    </ul>
  </div>
</template>

<script>
import { format } from 'date-fns';

export default {
  name: 'SearchBus',
  data: () => ({
    isLoading: false,
    folderName: '',

    // 搜尋表單
    form: {
      expectDepartureDate: '',   // 出發日期，預設今天
      expectDepartureTime: '',   // 出發時間，預設現在
      stationStart: '',          // 出發站
      stationEnd: '',            // 抵達站
      busType: '',               // 車型
      flightNO: '',              // 航班號
    },

    // 時刻表欄位標題
    fields: [ 'FOC', 'T1', 'T2', 'FCCC', 'GBTP', 'FOC', 'Bus Type','FlightNO.' ],
    busTypeList: [],    // 車類型
    busStationData: [], // 站點 (篩選 FOC/T1/T2/FCCC/GBTP)
    busNoticeData: [],  // 交通車公告
    resultData: [],     // 時刻表

    // 乘車注意事項彈窗控制
    showNoticeModal: false,      // 彈窗開關
  }),
  methods: {
     /**
     * 送出搜尋表單
     */
    async handleSubmit() {
      this.isLoading = true;
      try {
        const res = await this.getBusTimetable(
          localStorage.getItem('access_token'),
          this.form.stationStart,
          this.form.stationEnd,
          this.form.expectDepartureDate,
          this.form.expectDepartureTime,
          this.form.busType
        );
        this.resultData = (res.data.data && res.data.data.timetable) || [];
      } catch(err) {
        console.error(err);
        this.resultData = [];
      } finally {
        this.isLoading = false;
      }
    },

     /**
     * 取得底部注意事項
     */
    async busNotice() {
      try {
        const res = await this.getBusTimetableNotice(localStorage.getItem('access_token'));
        this.busNoticeData = (res.data.data && res.data.data.noticeList) || [];
      } catch(err) {
        console.error(err);
      }
    },

     /**
     * 取得站點清單
     * 篩選只保留 FOC / T1 / T2 / FCCC / GBTP
     */
    async busStations() {
      try {
        const res = await this.getBusStation(localStorage.getItem('access_token'));
        this.busStationData = (res.data.data && res.data.data.stationList || []).filter((station) => {
          return ['FOC', 'T1', 'T2', 'FCCC', 'GBTP'].includes(station.code);
        });
      } catch(err) {
        console.error(err);
      }
    },

    /**
     * 取得車型清單
    */
    async busType() {
      try {
        const res = await this.getBusType(localStorage.getItem('access_token'));
        this.busTypeList = (res.data.data && res.data.data.busList) || [];
      } catch(err) {
        console.error(err);
      }
    },

    /**
     * 關閉乘車注意事項彈窗
     */
    closeNoticeModal() {
      this.showNoticeModal = false;
    },

    /**
     * 把單一班次的站點資料，轉換成表格要顯示的時間清單
     * @param {Array} stationList - 這班車的站點清單
     * @returns {Array} 6 個時間字串，順序對應表頭的 FOC/T1/T2/FCCC/GBTP/FOC
     */
    formatBusTime(stationList) {
      const list = stationList || [];
      return Array.from({ length: 6 }, (_, i) => (list[i] && list[i].scheduledTime) || '-');
    },
  },

  async created() {
    this.folderName = this.$route.name;
    this.form.expectDepartureDate = format(new Date(), 'yyyy-MM-dd');
    this.form.expectDepartureTime = format(new Date(), 'HH:mm');
    this.isLoading = true;
    await Promise.all([
      this.busNotice(),
      this.busStations(),
      this.busType(),
    ]);
    await this.handleSubmit();
    this.isLoading = false;

    if (this.busNoticeData.length) this.showNoticeModal = true;
  },

  /**
   * keep-alive 每次切回此 tab 時觸發
   * 重新開啟乘車注意事項彈窗
   */
  activated() {
  if (this.busNoticeData.length) this.showNoticeModal = true;
  },
  };
</script>

<style lang="scss" scoped>
.card {
  min-height: calc(100vh - 180px);
}

.tran-select-area {
  display: grid;
  align-items: end;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 20px;
  padding: 1rem;
  margin-bottom: 3rem;
}

.tran-input-group {
  label,select,input {
    font-size: 15px;
  }

  label {
    margin: 0 0 7px 8px;
    color: #84754E;
    font-weight: bold;
  }

  .form-control {
    border-radius: 8px;
  }
}

.tran-table-btn {
  border-radius: 8px;
  font-size: 15px;
  width: 55%;
  min-width: fit-content;
  justify-self: end;
  white-space: nowrap;
}

.date-input {
  input {
    width: 48%;
    border: none;
    background-color: none;
  }
}

.tran-table-outlay {
  max-height: calc(100vh - 340px);
  overflow-y: auto;
  position: relative;
  margin-bottom: 4rem;

  .empty-outlay {
    min-height: 400px;
  }

  .loading {
    position: absolute;
    background: none;
    z-index: 1;
  }

  .icon {
    box-shadow: none;
  }

  .table {
    border-collapse: collapse;
    width: 100%;
    th,
    td {
      border-top: none;
      border-bottom: 1px solid #dee2e6;
      font-size: 15px;
      vertical-align: middle;
      text-align: center;
      white-space: nowrap;
      width: 100px;
      box-sizing: border-box;
    }

    thead th {
      background-color: #fff;
      border-bottom: 1px solid transparent;
      vertical-align: middle;
      white-space: nowrap;
    }

    td {
      white-space: normal;
    }
  }

  .table-hover {
    tbody tr:hover {
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.08), 0 0 8px rgba(0, 0, 0, 0.08);
      background-color: #fff;
    }
  }
}

.empty-status {
  padding: 70px 0;
}

.head-fixed {
  position: sticky;
  top: 0px;
}

.notice-text {
  font-size: 13px;
  color: #666;
  list-style-type: disc;
}

/* 手機/平板版：交通車班次卡片 */
.bus-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.bus-card {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 16px 18px;
}
/* 六站時間，格狀排列 */
.bus-card-stations {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f1f1f1;
}
.bus-card-station {
  text-align: center;
}
.bus-card-station-code {
  font-size: 12px;
  color: #84754E;
  font-weight: 600;
  margin-bottom: 4px;
}
.bus-card-station-time {
  font-size: 15px;
  color: #212529;
  font-weight: 600;
}
.bus-card-meta {
  font-size: 14px;
  color: #212529;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px;
}
.bus-card-flight {
  color: #84754E;
  font-weight: 500;
}

/* 彈窗遮罩，active 時顯示 */
.overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  align-items: center;
  justify-content: center;
  &.active { display: flex; }
}

/* 彈窗本體 */
.dialog {
  background: #ffffff;
  border-radius: 12px;
  border: 0.5px solid #e9ecef;
  width: 340px;
  max-height: 60vh;
  display: flex;             
  flex-direction: column;   
  overflow: hidden;
  &--notice { width: 460px; }
}

.dialog-header {
  padding: 1rem 1.25rem;
  border-bottom: 0.5px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.dialog-title {
  font-size: 15px;
  font-weight: 500;
}

.dialog-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6c757d;
  font-size: 18px;
}

.dialog-body {
  padding: 1.25rem;
  overflow-y: auto; 
  flex: 1;  
}

.dialog-footer {
  padding: 1rem 1.25rem;
  border-top: 0.5px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.notice-modal-list {
  padding-left: 1.25rem;
  margin: 0;
  li {
    font-size: 14px;
    line-height: 2;
    list-style: disc;
  }
}

.btn-notice-confirm {
  padding: 7px 18px;
  font-size: 13px;
  font-weight: 500;
  background: #84754E;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  &:hover { opacity: 0.85; }
}

@media screen and (max-width: 991px) {
  .card {
    min-height: calc(100vh - 205px);
  }
  .tran-select-area {
    grid-template-columns: 1fr 1fr 2fr 1fr 1fr;
  }
}

@media screen and (max-width: 767px) {
  .tran-select-area {
    display: block;
    grid-gap: 0;
    padding: 0 0.5rem;
    margin-bottom: 0;
  }
  .tran-table-btn {
    margin: 2rem 0;
    width: 100%;
  }
  .tran-table-outlay {
    max-height: calc(100vh - 225px);
    .empty-outlay {
      min-height: 150px;
    }
  }
  .dialog--notice {
    width: calc(100vw - 32px);
    max-height: 50vh;
  }
  .empty-status {
    padding: 30px 0;
  }
}

@media screen and (max-height: 500px) {
  .tran-table-outlay {
    max-height: calc(100vh - 130px);
  }
  .dialog--notice {
    max-height: 60vh;
  }
}
</style>